import type { IJobApplication } from '../../stores/JobApplicationStore/JobApplication';
import { logError } from '../../utils/logError';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import type { useToast } from 'braid-design-system';

export interface UseHandleErrorResponse {
  handleError: (
    showToast: ReturnType<typeof useToast>,
    jobApplication: IJobApplication,
    logErrorMessage: string,
  ) => void;
}

const useHandleError = (): UseHandleErrorResponse => {
  const { t } = useTranslations(translations);
  return {
    handleError: (
      showToast: ReturnType<typeof useToast>,
      jobApplication: IJobApplication,
      logErrorMessage: string,
    ) => {
      jobApplication.setIsChangingState(false);
      showToast({
        closeLabel: t('Close'),
        tone: 'critical',
        message: t('Sorry, we couldn’t save your changes. Can we try again?'),
        key: 'STATUS_CHANGE_ERROR_TOAST_KEY',
      });
      logError(
        {
          errorCode: 'UPDATE_STATUS',
          description: 'Error changing status',
        },
        {
          errorMessage: logErrorMessage,
        },
      );
    },
  };
};

export default useHandleError;
